import {
  PriceTierDeleteAndReassignRequestType,
  PriceTierDeleteAndReassignResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceTierDeleteAndReassign = (priceTierId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceTierDeleteAndReassignRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `price-tiers/${priceTierId}/delete-and-reassign`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PriceTierDeleteAndReassignResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers, priceTierId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
